import React from "react";
import {
	AutocompleteInput,
	DateInput,
	ReferenceInput,
	required,
	SelectInput,
	SimpleForm,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import CsvInput from "./inputs/CsvInput";
import types from "./types";

const Form = (props) => {
	return (
		<SimpleForm {...props} redirect="list">
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				validate={required()}
				{...bookmakersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<SelectInput source="type" initialValue="stats" choices={types} />
			<DateInput source="date" validate={[required()]} />
			<CsvInput source="csv" validate={[required()]} />
		</SimpleForm>
	);
};
export default Form;
